import { createApp, h, provide } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { DefaultApolloClient } from "@vue/apollo-composable";
import { init as initFullStory } from "@fullstory/browser";
import ApolloClient from "@/apollo-client";
import { productFruits } from "product-fruits";

import App from "./App.vue";
import "./registerServiceWorker";
import router from "./Router";
import "./assets/css/tailwind.css";
import "./assets/css/style.css";
import { vue3Debounce } from "vue-debounce";
import Emitter from "@/Services/emitter";
import Sentry from "@/sentry";

console.log("--->*>*>*** Launching dashboard ***<*<*<---");
initFullStory({ orgId: "190J6X" }, ({ sessionUrl }) => console.log(`Started session: ${sessionUrl} `));

Sentry.initialize();

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

productFruits.init(
  "ZnLckJiXN6YDrnV7",
  "en",
  { username: "anonymous" },
  { disableLocationChangeDetection: true }
);

createApp({
  setup() {
    provide(DefaultApolloClient, ApolloClient);
  },
  render: () => h(App),
})
  .provide("emitter", Emitter.emitter)
  .use(router)
  .use(pinia)
  .directive("debounce", vue3Debounce({ lock: true, defaultTime: "500ms" }))
  .mount("#app");
